import { combineReducers } from "redux";
import main from "redux/main/reducers";
import stat from "redux/stat/reducers";
import sites from "redux/sites/reducers";
import user from "redux/authenticate/reducers";
import { reducer as form } from "redux-form";

export default combineReducers({
  main,
  sites,
  user,
  stat,
  form
});
